import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
export const useTransformationFunctionsStore = defineStore("transformationFunctions", () => {
    const detail = ref({});
    const list = ref([]);
    const isLoading = ref(false);
    const filter = ref({
        limit: 20,
        offset: 0
    });
    function setDetail(data) {
        detail.value = data;
    }
    function updateFilterField(field, value) {
        filter.value[field] = value;
    }
    async function getDetail(id) {
        isLoading.value = true;
        const { data } = await client.path("/transformations/{transformationId}").method("get").create()({
            transformationId: String(id)
        });
        detail.value = data.data ?? {};
        isLoading.value = false;
    }
    async function getList() {
        isLoading.value = true;
        const { data } = await client.path("/transformations").method("get").create()({ limit: 1000, offset: 0 });
        list.value = data.data ?? [];
        isLoading.value = false;
    }
    async function create() {
        isLoading.value = true;
        const { data } = await client.path("/transformations").method("post").create()({
            ...detail.value
        });
        isLoading.value = false;
        return data.transformationId;
    }
    async function testRun(payload) {
        const { data } = await client.path("/transformations/test-run").method("post").create()(payload);
        return data;
    }
    async function update() {
        isLoading.value = true;
        await client.path("/transformations/{transformationId}").method("put").create()({
            transformationId: String(detail.value.transformationId),
            ...detail.value
        });
        isLoading.value = false;
    }
    async function deleteTransformation(id) {
        isLoading.value = true;
        await client.path("/transformations/{transformationId}").method("delete").create()({ transformationId: String(id) });
        isLoading.value = false;
    }
    return {
        detail,
        list,
        isLoading,
        filter,
        setDetail,
        updateFilterField,
        getDetail,
        getList,
        create,
        testRun,
        update,
        deleteTransformation
    };
});
